import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'gp-theme';
  private _isDark = false;

  constructor() {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    this._isDark = stored === 'dark';
    this.apply();
  }

  get isDark(): boolean { return this._isDark; }

  toggle(): void {
    this._isDark = !this._isDark;
    localStorage.setItem(this.STORAGE_KEY, this._isDark ? 'dark' : 'light');
    this.apply();
  }

  private apply(): void {
    document.documentElement.setAttribute('data-theme', this._isDark ? 'dark' : 'light');
  }
}
